import { ElementType, ReactNode } from 'react';

import clsx from 'clsx';

import classes from './Text.module.css';

export const textVariants = [
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'body1',
  'body2',
  'body3',
  'caption',
  'inherit',
] as const;

export type ETextVariant = typeof textVariants[number];

export type TText = {
  align?: 'center' | 'inherit' | 'justify' | 'left' | 'right';
  children: ReactNode;
  className?: string;
  'data-testid'?: string;
  component?: ElementType;
  inheritColor?: boolean;
  variant?: ETextVariant;
};

export default function Text({
  align,
  children,
  className = '',
  component: Component = 'p',
  'data-testid': dataTestId,
  inheritColor = false,
  variant = 'body1',
}: TText) {
  return (
    <Component
      data-testid={dataTestId}
      className={clsx(classes.root, className, {
        [classes.h1]: variant === 'h1',
        [classes.h2]: variant === 'h2',
        [classes.h3]: variant === 'h3',
        [classes.h4]: variant === 'h4',
        [classes.h5]: variant === 'h5',
        [classes.h6]: variant === 'h6',
        [classes.body1]: variant === 'body1',
        [classes.body2]: variant === 'body2',
        [classes.body3]: variant === 'body3',
        [classes.caption]: variant === 'caption',
        [classes.inherit_all]: variant === 'inherit',
        [classes.inherit_color]: inheritColor,
        [classes[`text_align_${align}`]]: !!align,
      })}
    >
      {children}
    </Component>
  );
}
